import { Injectable } from '@angular/core';

@Injectable()
export class AdErrorCollectConfig {
  /**
   * çå¬é¢ç
   */
  freq?: number = 500;
  /**
   * é¡¶é¨åç§»å¼
   */
  offsetTop?: number = 65 + 64 + 8 * 2;
}
